import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_fee2274a from 'nuxt_plugin_plugin_fee2274a' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_nuxtplugin556e5640_573d5d93 from 'nuxt_plugin_nuxtplugin556e5640_573d5d93' // Source: ./nuxt.plugin.556e5640.js (mode: 'server')
import nuxt_plugin_vuescrollto_39df8ca0 from 'nuxt_plugin_vuescrollto_39df8ca0' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_388592f1 from 'nuxt_plugin_cookieuniversalnuxt_388592f1' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_3c8e37dc from 'nuxt_plugin_pluginutils_3c8e37dc' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_23b29834 from 'nuxt_plugin_pluginseo_23b29834' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_0d10b4dd from 'nuxt_plugin_pluginrouting_0d10b4dd' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_db82a89c from 'nuxt_plugin_pluginmain_db82a89c' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_distplugin8a63db02_79a72a49 from 'nuxt_plugin_distplugin8a63db02_79a72a49' // Source: ./dist.plugin.8a63db02.mjs (mode: 'all')
import nuxt_plugin_image_47e6bb78 from 'nuxt_plugin_image_47e6bb78' // Source: ./image.js (mode: 'all')
import nuxt_plugin_coreplugin4e47119c_a7f3ac0a from 'nuxt_plugin_coreplugin4e47119c_a7f3ac0a' // Source: ./core.plugin.4e47119c.ts (mode: 'all')
import nuxt_plugin_pluginse2etesting796f3508_774a465c from 'nuxt_plugin_pluginse2etesting796f3508_774a465c' // Source: ./plugins.e2e-testing.796f3508.js (mode: 'all')
import nuxt_plugin_deviceplugin_d8a83858 from 'nuxt_plugin_deviceplugin_d8a83858' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_4801ec25 from 'nuxt_plugin_workbox_4801ec25' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_06d98390 from 'nuxt_plugin_metaplugin_06d98390' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_013ae3ac from 'nuxt_plugin_iconplugin_013ae3ac' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_tokenexpired_ca1e20ca from 'nuxt_plugin_tokenexpired_ca1e20ca' // Source: ../plugins/token-expired (mode: 'all')
import nuxt_plugin_focuslist_472dfcf0 from 'nuxt_plugin_focuslist_472dfcf0' // Source: ../plugins/focus-list.client (mode: 'client')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_fcPlugin_5a846bc6 from 'nuxt_plugin_fcPlugin_5a846bc6' // Source: ../plugins/fcPlugin (mode: 'all')
import nuxt_plugin_dompurify_9e093c4a from 'nuxt_plugin_dompurify_9e093c4a' // Source: ../plugins/dompurify (mode: 'all')
import nuxt_plugin_storeConfigPlugin_234467e0 from 'nuxt_plugin_storeConfigPlugin_234467e0' // Source: ../plugins/storeConfigPlugin (mode: 'all')
import nuxt_plugin_meta_766c222d from 'nuxt_plugin_meta_766c222d' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"INNERECOMMERCE - DEMO WEB STORE","meta":[{"hid":"robots","name":"robots","content":"noindex, nofollow"},{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"favicon.ico"}],"style":[],"script":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_fee2274a === 'function') {
    await nuxt_plugin_plugin_fee2274a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugin556e5640_573d5d93 === 'function') {
    await nuxt_plugin_nuxtplugin556e5640_573d5d93(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_39df8ca0 === 'function') {
    await nuxt_plugin_vuescrollto_39df8ca0(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_388592f1 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_388592f1(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_3c8e37dc === 'function') {
    await nuxt_plugin_pluginutils_3c8e37dc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_23b29834 === 'function') {
    await nuxt_plugin_pluginseo_23b29834(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_0d10b4dd === 'function') {
    await nuxt_plugin_pluginrouting_0d10b4dd(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_db82a89c === 'function') {
    await nuxt_plugin_pluginmain_db82a89c(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin8a63db02_79a72a49 === 'function') {
    await nuxt_plugin_distplugin8a63db02_79a72a49(app.context, inject)
  }

  if (typeof nuxt_plugin_image_47e6bb78 === 'function') {
    await nuxt_plugin_image_47e6bb78(app.context, inject)
  }

  if (typeof nuxt_plugin_coreplugin4e47119c_a7f3ac0a === 'function') {
    await nuxt_plugin_coreplugin4e47119c_a7f3ac0a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting796f3508_774a465c === 'function') {
    await nuxt_plugin_pluginse2etesting796f3508_774a465c(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_d8a83858 === 'function') {
    await nuxt_plugin_deviceplugin_d8a83858(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_4801ec25 === 'function') {
    await nuxt_plugin_workbox_4801ec25(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_06d98390 === 'function') {
    await nuxt_plugin_metaplugin_06d98390(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_013ae3ac === 'function') {
    await nuxt_plugin_iconplugin_013ae3ac(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenexpired_ca1e20ca === 'function') {
    await nuxt_plugin_tokenexpired_ca1e20ca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_focuslist_472dfcf0 === 'function') {
    await nuxt_plugin_focuslist_472dfcf0(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_fcPlugin_5a846bc6 === 'function') {
    await nuxt_plugin_fcPlugin_5a846bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_dompurify_9e093c4a === 'function') {
    await nuxt_plugin_dompurify_9e093c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_storeConfigPlugin_234467e0 === 'function') {
    await nuxt_plugin_storeConfigPlugin_234467e0(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_766c222d === 'function') {
    await nuxt_plugin_meta_766c222d(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
